import { colors } from '../../theme/colors';

import { styled } from '@mui/system';
import { Box, Button } from '@mui/material';


export const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  textAlign: 'center',
  backgroundColor: '#f4f6f8',
  padding: '16px',
  color: colors.primary,
  flexDirection: 'row',
  justifyContent: 'center',

  '& .leftContent': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'justify',
    '& .MuiTypography-h3': {
      fontWeight: 600,
      '@media (max-width: 900px)': {
        fontSize: "1.7rem"
      },
      '@media (max-width: 620px)': {
        fontSize: "1 rem"
      },
    },
    "& .MuiTypography-body1": {
      '@media (max-width: 900px)': {
        fontSize: "0.8rem"
      },
    }

  },
      '@media (max-width: 619px)': {
        flexDirection: 'column-reverse',
      },
    

});

export const IconContainer = styled(Box)({
  color: colors.primary,
});

export const CustomButton = styled(Button)({
  backgroundColor: colors.primary,
  borderRadius: '10px',
  fontWeight: 400,
  color: '#fff',
  '&:hover': {
    backgroundColor: colors.primary, // Change this to the color you want on hover
  },
  '@media (max-width: 900px)': {
    width: "0.7rem",
    fontSize: "0.7rem"
  },
});
